import { useEffect } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import GeoJSON from 'ol/format/GeoJSON';
import { validatedParcelLayer } from '@/ol/layers';
import { proj3857, proj4326 } from '@/ol/proj';
import { selectedParcellesIduState, validatedParcellesState } from '@/store';

/**
 * Hook to synchronize the validated parcelles with the validated parcel layer.
 */
export default function useValidatedParcelleSync() {
  const validatedParcelleFC = useAtomValue(validatedParcellesState);
  const setSelectedParcellesIdu = useSetAtom(selectedParcellesIduState);

  useEffect(() => {
    const validatedParcelSrc = validatedParcelLayer.getSource();
    validatedParcelSrc.clear();

    setSelectedParcellesIdu([]);

    validatedParcelSrc.addFeatures(
      new GeoJSON({
        dataProjection: proj4326,
        featureProjection: proj3857,
      }).readFeatures(validatedParcelleFC),
    );
  }, [validatedParcelleFC, setSelectedParcellesIdu]);
}
